export default __webpack_public_path__ + "static/media/prev-disabled.470acb10.svg";